export const MANUAL_EDIT_APPRAISAL_REVIEW = 'Manual';
export const AUTOMATED_EDIT_APPRAISAL_REVIEW = 'Automated';
export const MANUAL_SECTION = 'Subject Property Photos Addendum Review';
export const TAMARISK_APPRAISAL_AMC = 'tamarisk';
export const TAMARISK_OPTION_NOT_ALLOWED = 'This is not a Tamarisk Appraisal, please select another option.';
export const SCOPE_OF_WORK_INVALID = 'Please note that there is no Scope of Work defined for this property. Kindly ensure that the Scope of Work is completed before sending the document to CMT';
export const PLEASE_SELECT_AN_OPTION_TO_CONTINUE = 'Please select at least one appraisal revision to be sent.';
export const OCR_FAILED_STATUS = 'ocrFailed';